/* tslint:disable */
/* eslint-disable */
/**
 * BonusX
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { FamilyMember } from '../models';
// @ts-ignore
import type { InputUpdateFamilyMembers } from '../models';
/**
 * FamilyApi - axios parameter creator
 * @export
 */
export const FamilyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *  **Permission required**: [\"update\", \"FamilyMember\"] 
         * @summary Delete a family member by id | Permission required: [\"update\", \"FamilyMember\"]
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAFamilyMemberById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteAFamilyMemberById', 'id', id)
            const localVarPath = `/citizen/family/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  **Permission required**: [\"readAll\", \"FamilyMember\"] 
         * @summary Get family members | Permission required: [\"readAll\", \"FamilyMember\"]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFamilyMembers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/citizen/family/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  **Permission required**: [\"update\", \"FamilyMember\"] 
         * @summary Update family members | Permission required: [\"update\", \"FamilyMember\"]
         * @param {InputUpdateFamilyMembers} [inputUpdateFamilyMembers] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFamilyMembers: async (inputUpdateFamilyMembers?: InputUpdateFamilyMembers, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/citizen/family/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputUpdateFamilyMembers, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FamilyApi - functional programming interface
 * @export
 */
export const FamilyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FamilyApiAxiosParamCreator(configuration)
    return {
        /**
         *  **Permission required**: [\"update\", \"FamilyMember\"] 
         * @summary Delete a family member by id | Permission required: [\"update\", \"FamilyMember\"]
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAFamilyMemberById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FamilyMember>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAFamilyMemberById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FamilyApi.deleteAFamilyMemberById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  **Permission required**: [\"readAll\", \"FamilyMember\"] 
         * @summary Get family members | Permission required: [\"readAll\", \"FamilyMember\"]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFamilyMembers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FamilyMember>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFamilyMembers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FamilyApi.getFamilyMembers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  **Permission required**: [\"update\", \"FamilyMember\"] 
         * @summary Update family members | Permission required: [\"update\", \"FamilyMember\"]
         * @param {InputUpdateFamilyMembers} [inputUpdateFamilyMembers] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFamilyMembers(inputUpdateFamilyMembers?: InputUpdateFamilyMembers, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FamilyMember>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFamilyMembers(inputUpdateFamilyMembers, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FamilyApi.updateFamilyMembers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FamilyApi - factory interface
 * @export
 */
export const FamilyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FamilyApiFp(configuration)
    return {
        /**
         *  **Permission required**: [\"update\", \"FamilyMember\"] 
         * @summary Delete a family member by id | Permission required: [\"update\", \"FamilyMember\"]
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAFamilyMemberById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<FamilyMember> {
            return localVarFp.deleteAFamilyMemberById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"readAll\", \"FamilyMember\"] 
         * @summary Get family members | Permission required: [\"readAll\", \"FamilyMember\"]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFamilyMembers(options?: RawAxiosRequestConfig): AxiosPromise<Array<FamilyMember>> {
            return localVarFp.getFamilyMembers(options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"update\", \"FamilyMember\"] 
         * @summary Update family members | Permission required: [\"update\", \"FamilyMember\"]
         * @param {InputUpdateFamilyMembers} [inputUpdateFamilyMembers] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFamilyMembers(inputUpdateFamilyMembers?: InputUpdateFamilyMembers, options?: RawAxiosRequestConfig): AxiosPromise<Array<FamilyMember>> {
            return localVarFp.updateFamilyMembers(inputUpdateFamilyMembers, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FamilyApi - interface
 * @export
 * @interface FamilyApi
 */
export interface FamilyApiInterface {
    /**
     *  **Permission required**: [\"update\", \"FamilyMember\"] 
     * @summary Delete a family member by id | Permission required: [\"update\", \"FamilyMember\"]
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FamilyApiInterface
     */
    deleteAFamilyMemberById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<FamilyMember>;

    /**
     *  **Permission required**: [\"readAll\", \"FamilyMember\"] 
     * @summary Get family members | Permission required: [\"readAll\", \"FamilyMember\"]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FamilyApiInterface
     */
    getFamilyMembers(options?: RawAxiosRequestConfig): AxiosPromise<Array<FamilyMember>>;

    /**
     *  **Permission required**: [\"update\", \"FamilyMember\"] 
     * @summary Update family members | Permission required: [\"update\", \"FamilyMember\"]
     * @param {InputUpdateFamilyMembers} [inputUpdateFamilyMembers] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FamilyApiInterface
     */
    updateFamilyMembers(inputUpdateFamilyMembers?: InputUpdateFamilyMembers, options?: RawAxiosRequestConfig): AxiosPromise<Array<FamilyMember>>;

}

/**
 * FamilyApi - object-oriented interface
 * @export
 * @class FamilyApi
 * @extends {BaseAPI}
 */
export class FamilyApi extends BaseAPI implements FamilyApiInterface {
    /**
     *  **Permission required**: [\"update\", \"FamilyMember\"] 
     * @summary Delete a family member by id | Permission required: [\"update\", \"FamilyMember\"]
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FamilyApi
     */
    public deleteAFamilyMemberById(id: number, options?: RawAxiosRequestConfig) {
        return FamilyApiFp(this.configuration).deleteAFamilyMemberById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  **Permission required**: [\"readAll\", \"FamilyMember\"] 
     * @summary Get family members | Permission required: [\"readAll\", \"FamilyMember\"]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FamilyApi
     */
    public getFamilyMembers(options?: RawAxiosRequestConfig) {
        return FamilyApiFp(this.configuration).getFamilyMembers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  **Permission required**: [\"update\", \"FamilyMember\"] 
     * @summary Update family members | Permission required: [\"update\", \"FamilyMember\"]
     * @param {InputUpdateFamilyMembers} [inputUpdateFamilyMembers] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FamilyApi
     */
    public updateFamilyMembers(inputUpdateFamilyMembers?: InputUpdateFamilyMembers, options?: RawAxiosRequestConfig) {
        return FamilyApiFp(this.configuration).updateFamilyMembers(inputUpdateFamilyMembers, options).then((request) => request(this.axios, this.basePath));
    }
}

